'use strict';

var _classCallCheck = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/createClass");

var connect = require('pull-ws/client');

var mafmt = require('mafmt');

var withIs = require('class-is');

var includes = require('lodash.includes');

var Connection = require('interface-connection').Connection;

var maToUrl = require('./ma-to-url');

var debug = require('debug');

var log = debug('libp2p:websockets:dialer');

var _createListener = require('./listener');

var WebSockets =
/*#__PURE__*/
function () {
  function WebSockets() {
    _classCallCheck(this, WebSockets);
  }

  _createClass(WebSockets, [{
    key: "dial",
    value: function dial(ma, options, callback) {
      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      callback = callback || function () {};

      var url = maToUrl(ma);
      log('dialing %s', url);
      var socket = connect(url, {
        binary: true,
        onConnect: function onConnect(err) {
          callback(err);
        }
      });
      var conn = new Connection(socket);

      conn.getObservedAddrs = function (cb) {
        return cb(null, [ma]);
      };

      conn.close = function (cb) {
        return socket.close(cb);
      };

      return conn;
    }
  }, {
    key: "createListener",
    value: function createListener(options, handler) {
      if (typeof options === 'function') {
        handler = options;
        options = {};
      }

      return _createListener(options, handler);
    }
  }, {
    key: "filter",
    value: function filter(multiaddrs) {
      if (!Array.isArray(multiaddrs)) {
        multiaddrs = [multiaddrs];
      }

      return multiaddrs.filter(function (ma) {
        if (includes(ma.protoNames(), 'p2p-circuit')) {
          return false;
        }

        if (includes(ma.protoNames(), 'ipfs')) {
          ma = ma.decapsulate('ipfs');
        }

        return mafmt.WebSockets.matches(ma) || mafmt.WebSocketsSecure.matches(ma);
      });
    }
  }]);

  return WebSockets;
}();

module.exports = withIs(WebSockets, {
  className: 'WebSockets',
  symbolName: '@libp2p/js-libp2p-websockets/websockets'
});